import { render, staticRenderFns } from "./ChooseOrganization.vue?vue&type=template&id=19c1397b&"
import script from "./ChooseOrganization.vue?vue&type=script&lang=js&"
export * from "./ChooseOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrganization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports